import type { InclusiveState } from '../types';

export function track(
    state: InclusiveState,
    feature: string,
    profile?: string,
): void {
    const base = state.options.apiBaseUrl ?? '';

    const payload = JSON.stringify({
        sessionId: state.sessionId,
        events: [
            {
                feature,
                profile: profile ?? state.profile,
                language: state.language,
                occurredAt: new Date().toISOString(),
            },
        ],
    });

    try {
        void fetch(`${base}/api/v1/analytics/events`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Application-Id': state.options.applicationId,
                'X-Sdk-Version': '1.0.0',
            },
            body: payload,
            keepalive: true,
        }).catch(() => {
            // Analytics must never break the widget.
        });
    } catch {
        // Analytics must never break the widget.
    }
}
